export default __webpack_public_path__ + "static/media/premier-logo.4a5af314.png";